export enum ConsultantWorkStatusType {
  PermanentPosition = "PermanentPosition",
  WorkingForCompetitor = "WorkingForCompetitor",
  Retired = "Retired",
  PartTimeConsultant = "PartTimeConsultant",
  FullTimeConsultant = "FullTimeConsultant",
  OnSickLeave = "OnSickLeave"
}
